// are running. We don't want to fall back by default to Prod unless we know for certain that
// sovereign accounts are not possible.
export var validEnvironments = [
    "Df",
    "Msit",
    "Prod",
    "Blackforest",
    "GccModerate",
    "GccHigh",
    "DoD",
    "Gallatin",
    "AG08",
    "AG09",
    "Unknown",
];
export var validRegions = ["msit", "df"];
export function validateComplianceEnvironment(complianceEnvironment) {
    if ("Df" === complianceEnvironment) {
        return "Df";
    }
    if ("Msit" === complianceEnvironment) {
        return "Msit";
    }
    if ("Prod" === complianceEnvironment) {
        return "Prod";
    }
    if ("Blackforest" === complianceEnvironment) {
        return "Blackforest";
    }
    if ("GccModerate" === complianceEnvironment) {
        return "GccModerate";
    }
    if ("GccHigh" === complianceEnvironment) {
        return "GccHigh";
    }
    if ("DoD" === complianceEnvironment) {
        return "DoD";
    }
    if ("Gallatin" === complianceEnvironment) {
        return "Gallatin";
    }
    if ("AG08" === complianceEnvironment) {
        return "AG08";
    }
    if ("AG09" === complianceEnvironment) {
        return "AG09";
    }
    if ("Unknown" === complianceEnvironment) {
        return "Unknown";
    }
    return "Unknown";
}
export var GET_AUTH_TOKEN_SCENARIO = "LokiGetAuthToken";
export var GET_AUTH_TOKEN_FAILED = "LokiGetAuthTokenFailed";
export var AUTH_TOKEN_RECEIVED_AFTER_TIMEOUT = "LokiAuthTokenReceivedAfterTimeout";
export { NOVA_TELEMETRY_EVENT_TYPE } from "./telemetry";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY0EsNkZBQTZGO0FBQzdGLHVDQUF1QztBQUV2QyxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBc0I7SUFDbEQsSUFBSTtJQUNKLE1BQU07SUFDTixNQUFNO0lBQ04sYUFBYTtJQUNiLGFBQWE7SUFDYixTQUFTO0lBQ1QsS0FBSztJQUNMLFVBQVU7SUFDVixNQUFNO0lBQ04sTUFBTTtJQUNOLFNBQVM7Q0FDVixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sWUFBWSxHQUFrQixDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUMsQ0FBQztBQUUxRCxNQUFNLFVBQVUsNkJBQTZCLENBQzNDLHFCQUF5QztJQUV6QyxJQUFJLElBQUksS0FBSyxxQkFBcUIsRUFBRTtRQUNsQyxPQUFPLElBQUksQ0FBQztLQUNiO0lBQ0QsSUFBSSxNQUFNLEtBQUsscUJBQXFCLEVBQUU7UUFDcEMsT0FBTyxNQUFNLENBQUM7S0FDZjtJQUNELElBQUksTUFBTSxLQUFLLHFCQUFxQixFQUFFO1FBQ3BDLE9BQU8sTUFBTSxDQUFDO0tBQ2Y7SUFDRCxJQUFJLGFBQWEsS0FBSyxxQkFBcUIsRUFBRTtRQUMzQyxPQUFPLGFBQWEsQ0FBQztLQUN0QjtJQUNELElBQUksYUFBYSxLQUFLLHFCQUFxQixFQUFFO1FBQzNDLE9BQU8sYUFBYSxDQUFDO0tBQ3RCO0lBQ0QsSUFBSSxTQUFTLEtBQUsscUJBQXFCLEVBQUU7UUFDdkMsT0FBTyxTQUFTLENBQUM7S0FDbEI7SUFDRCxJQUFJLEtBQUssS0FBSyxxQkFBcUIsRUFBRTtRQUNuQyxPQUFPLEtBQUssQ0FBQztLQUNkO0lBQ0QsSUFBSSxVQUFVLEtBQUsscUJBQXFCLEVBQUU7UUFDeEMsT0FBTyxVQUFVLENBQUM7S0FDbkI7SUFDRCxJQUFJLE1BQU0sS0FBSyxxQkFBcUIsRUFBRTtRQUNwQyxPQUFPLE1BQU0sQ0FBQztLQUNmO0lBQ0QsSUFBSSxNQUFNLEtBQUsscUJBQXFCLEVBQUU7UUFDcEMsT0FBTyxNQUFNLENBQUM7S0FDZjtJQUNELElBQUksU0FBUyxLQUFLLHFCQUFxQixFQUFFO1FBQ3ZDLE9BQU8sU0FBUyxDQUFDO0tBQ2xCO0lBRUQsT0FBTyxTQUFTLENBQUM7QUFDbkIsQ0FBQztBQWtCRCxNQUFNLENBQUMsSUFBTSx1QkFBdUIsR0FBRyxrQkFBa0IsQ0FBQztBQUMxRCxNQUFNLENBQUMsSUFBTSxxQkFBcUIsR0FBRyx3QkFBd0IsQ0FBQztBQUM5RCxNQUFNLENBQUMsSUFBTSxpQ0FBaUMsR0FDNUMsbUNBQW1DLENBQUM7QUErQ3RDLE9BQU8sRUFBRSx5QkFBeUIsRUFBRSxNQUFNLGFBQWEsQ0FBQyJ9